<template>
  <div class="userinfo">
    <header-bar :name='"作品信息"'></header-bar>
    <div class="work_info_con">
      <div class="content">
        <div class="formWrap">
          <div class="formItem title clearfix">
            <div class="formName">标题</div>
            <div class="formCon">
              <textarea name="" id="" cols="10" rows="5" placeholder="请输入50字以内标题" maxlength="50" v-model="infoForm.title"></textarea>
            </div>
          </div>
          <div class="formItem note clearfix">
            <div class="formName">描述</div>
            <div class="formCon">
              <textarea name="" id="" cols="10" rows="5" placeholder="150字以内" maxlength="150" v-model="infoForm.desc"></textarea>
            </div>
          </div>
          <div class="formItem clearfix">
            <div class="formName">拍摄时间</div>
            <div class="formIcon">
              <img src="../img/m/calendar.png" alt="" class="calendar">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': firstTime}" @click="showTimePicker = true">
              {{firstTime ? '请选择' : new Date(shotTime).Format('YYYY年MM月')}}
            </div>
            <van-popup v-model="showTimePicker" position="bottom">
              <van-datetime-picker
                v-model="infoForm.time"
                type="date"
                title="选择年月日"
                @confirm="onConfirmTime"
                @cancel="showTimePicker = false"
              />
            </van-popup>
          </div>
          <div class="formItem clearfix">
            <div class="formName">国家</div>
            <div class="formIcon">
              <img src="../img/m/arrow_right.png" alt="" class="arrow">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': !infoForm.sid}" @click="showCountryPicker = true">
              {{infoForm.sid ? countryList.find(v => infoForm.sid == v.sid).cn : '请选择'}}
            </div>
            <van-popup v-model="showCountryPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key='cn'
                :columns="countryList"
                @confirm="onConfirmCountry"
                @cancel="showCountryPicker = false"
              />
            </van-popup>
          </div>
          <div class="formItem clearfix">
            <div class="formName">作品分类</div>
            <div class="formIcon">
              <img src="../img/m/arrow_right.png" alt="" class="arrow">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': !infoForm.category_id}" @click="showCategoryPicker = true">
            {{infoForm.category_id ? categoryList.find(v => infoForm.category_id == v.category_id).category_name : '请选择'}}
            </div>
            <van-popup v-model="showCategoryPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key='category_name'
                :columns="categoryList"
                @confirm="onConfirmCategory"
                @cancel="showCategoryPicker = false"
              />
            </van-popup>
          </div>
          <div class="formItem clearfix" v-if="infoForm.category_id">
            <div class="formName">作品话题</div>
            <div class="formIcon">
              <img src="../img/m/arrow_right.png" alt="" class="arrow">
            </div>
            <div class="formCon" style="line-height: 1.2rem" :class="{'conHolder': !infoForm.topic_id}" @click="showTopicPicker = true">
            {{infoForm.topic_id ? topicList.find(v => infoForm.topic_id == v.topic_id).topic_name : '请选择'}}
            </div>
            <van-popup v-model="showTopicPicker" position="bottom">
              <van-picker
                show-toolbar
                value-key='topic_name'
                :columns="topicList"
                @confirm="onConfirmTopic"
                @cancel="showTopicPicker = false"
              />
            </van-popup>
          </div>
        </div>
      </div>
      <div class="submit_btn" @click="submitForm()">
        完成
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { Notify } from 'vant'
import headerBar from './common/headerBar'

export default {
  components: {
    headerBar
  },
  data () {
    return {
      showCountryPicker: false,
      countryList: [],
      showCategoryPicker: false,
      categoryList: [],
      showTopicPicker: false,
      topicList: [],
      showTimePicker: false,
      firstTime: true,
      infoForm: {
        title: '',
        desc: '',
        time: new Date(),
        sid: undefined,
        category_id: undefined,
        topic_id: undefined
      },
      shotTime: new Date()
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.checkInfo()
    this.getCountryList()
    this.getCategoryList()
    if (this.$route.query.works_id) {
      this.getData()
    }
  },
  methods: {
    checkInfo () {
      if (this.getUserInfo.volunteer_info == 0) {
        this.$router.push({
          path: '/mpage/m_userinfo'
        })
      }
    },
    ...mapActions(['setPicWorkInfoAction']),
    // 国家picker
    onConfirmCountry (value) {
      this.infoForm.sid = value.sid
      this.showCountryPicker = false
    },
    // 分类picker
    onConfirmCategory (value) {
      this.infoForm.category_id = value.category_id
      this.showCategoryPicker = false
      this.getTopicList()
    },
    // 话题picker
    onConfirmTopic (value) {
      this.infoForm.topic_id = value.topic_id
      this.showTopicPicker = false
    },
    // 任职时间picker
    onConfirmTime (value) {
      this.firstTime = false
      this.infoForm.time = value
      this.shotTime = value
      this.showTimePicker = false
    },
    getCountryList () {
      this.$utils.get('/user/get-country-list').then(res => {
        this.countryList = res.data
      })
    },
    getCategoryList () {
      this.$utils.get('/works/getCategory').then(res => {
        this.categoryList = res.data
      })
    },
    getTopicList () {
      this.infoForm.topic_id = undefined
      this.$utils.get('/works/getTopic', {category_id: this.infoForm.category_id}).then(res => {
        this.topicList = res.data
      })
    },
    getData () {
      this.$utils.get('/works/getInfo', {works_id: this.$route.query.works_id}).then(res => {
        if (res.code == 1000) {
          let { title, desc, time, sid, category_id, topic_id } = res.data
          this.infoForm.title = title
          this.infoForm.desc = desc
          this.infoForm.time = new Date(+time * 1000)
          this.firstTime = false
          this.infoForm.sid = sid
          this.infoForm.category_id = category_id
          this.$utils.get('/works/getTopic', {category_id: this.infoForm.category_id}).then(res => {
            this.topicList = res.data
            this.infoForm.topic_id = topic_id
          })
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    },
    // 提交
    submitForm () {
      if (!this.infoForm.title) {
        Notify({ type: 'warning', message: '标题不能为空' })
        return
      }
      if (!this.infoForm.sid) {
        Notify({ type: 'warning', message: '国家不能为空' })
        return
      }
      if (!this.infoForm.category_id) {
        Notify({ type: 'warning', message: '分类不能为空' })
        return
      }
      if (!this.infoForm.topic_id) {
        Notify({ type: 'warning', message: '话题不能为空' })
        return
      }

      if (!this.$route.query.works_id) {
        this.setPicWorkInfoAction({
          title: this.infoForm.title,
          desc: this.infoForm.desc,
          time: this.infoForm.time,
          sid: this.infoForm.sid,
          category_id: this.infoForm.category_id,
          topic_id: this.infoForm.topic_id
        })
  
        this.$router.push({
          path: '/mpage/m_uploadpicwork'
        })
      } else {
        let param = {
          works_id: this.$route.query.works_id,
          ...this.infoForm
        }
        this.$utils.postForm('/works/api/updatePhoto', param).then(res => {
          if(res.code == 1000) {
            Notify({ type: 'success', duration: 1000, message: '修改成功!' })
            setTimeout(() => {
              this.$router.push({
                path: '/mpage/m_submit'
              })
            }, 1000)
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .content {
    padding: .3rem .45rem 0 .45rem;
    box-sizing: border-box;
    .formWrap {
      background: #fff;
      height: calc(100vh - 4.15rem);
    }
    .formItem {
      background: #fff;
      border-bottom: .01rem solid #ccc;
      padding: .4rem .78rem .4rem .7rem;
      box-sizing: border-box;
      line-height: 1.8;
      .formName {
        font-size: .6rem;
        color: #282828;
        float: left;
      }
      .formCon {
        float: right;
        width: 75%;
        height: 1.2rem;
        padding-right: 0.4rem;
        box-sizing: border-box;
        color: #282828;
        font-size: .45rem;
        text-align: right;
        &.conHolder {
          color: #999;
        }
        input {
          width: 100%;
          height: 1.2rem;
          color: #282828;
          display: block;
          background-color: transparent;
          border: 0;
          padding: 0;
          margin: 0;
          resize: none;
          text-align: right;
        }
      }
      .formIcon {
        float: right;
        .arrow {
          width: .3rem;
          margin-top: .35rem;
        }
        .calendar {
          width: .46rem;
          margin-top: .35rem;
        }
      }
      &.note {
        .formName {
          float: none;
        }
        .formCon {
          float: none;
          text-align: left;
          width: 100%;
          height: 3.5rem;
          padding: 0;
          input {
            text-align: left;
          }
          textarea {
            width: 100%;
            height: 3.5rem;
            border: 0;
            resize: none;
            padding: 0;
          }
        }
      }
      &.title {
        .formName {
          float: none;
        }
        .formCon {
          float: none;
          text-align: left;
          width: 100%;
          height: 2rem;
          padding: 0;
          input {
            text-align: left;
          }
          textarea {
            width: 100%;
            height: 2rem;
            border: 0;
            resize: none;
            padding: 0;
          }
        }
      }
    }
  }
  .submit_btn {
    width: 100%;
    height: 2.41rem;
    background-color: #333;
    color: #fff;
    font-size: .8rem;
    text-align: center;
    line-height: 2.41rem;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #999;
  }
}
</style>
